export default __webpack_public_path__ + "static/media/finder_filter_disable.b8b1106a.svg";